import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { AnnouncementOutlined } from '@material-ui/icons';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex'
    , flexDirection: 'row'
    , alignItems: 'center'
    , justifyContent: 'flex-start'
    , gap: '8px'
  }

  , icon: {
    backgroundColor: theme.palette.primary.pastel
    , display: 'flex'
    , flexDirection: 'column'
    , alignItens: 'center'
    , justifyContent: 'center'
    , padding: '5px'
    , borderRadius: '20px'
  }

  , spanText: {
    fontSize: '1em'
    , opacity: '0.80'
    , useSelect: 'none'
  }
}));

const UnsupportedMessage = ({ messageBody }) => {
  //  ****************
  //  ** Attributes **
  //  ****************
  const classes = useStyles();
  
  const [messageType, setMessageType] = useState('');

  //  ****************
  //  ** useEffects **
  //  ****************
  useEffect(() => {
    if (!messageBody) setMessageType('unknown');
    setMessageType(messageBody.split(': ').pop());
  }, [messageBody]);  

  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.container}>
      <span className={classes.icon}>
        <AnnouncementOutlined />
      </span>

      <span className={classes.spanText}>
        {i18n.t('unsupportedMessage.description').replace('<param>', messageType)}
      </span>
    </div>
  );
};

export default UnsupportedMessage;
